// extracted by mini-css-extract-plugin
export var dividerLine = "_4c-0";
export var errorBackground = "_4c-1";